export const HOUSING_GET_SUCCESS = 'HOUSING_GET_SUCCESS';
export const HOUSING_GET_FAILURE = 'HOUSING_GET_FAILURE';

export const HOUSING_SUCCESS = 'HOUSING_SUCCESS';
export const HOUSING_FAILURE = 'HOUSING_FAILURE';
